/* eslint-disable no-shadow */
import React, { useState } from 'react';
import { connect } from 'react-redux';
import { Button, Modal, ModalHeader, ModalBody, ModalFooter, Row, Col, Label } from 'reactstrap';
import AddBoxNumber from './AddBoxNumber';
import { addNumberModalCancel, cancelAddNumber, editNumberCancel } from '../../../actions/Numbers';
import { getGateways } from '../../../actions/Provisioning';
import EditBoxNumber from './EditBoxNumber';
import Toggle from '../../Toggle';
import EditBoxAtaNumber from './EditBoxAtaNumber';

const AddAtaBoxNumberModal = ({
  isOpen,
  onConfirm,
  onCancel,
  boxDetails,
  cancelAddNumber,
  editNumberCancel,
  selectRoute,
  gateways,
  onEditPropertyKeyPress,
  vmail,
}) => {
  const [toggleState, setToggleState] = useState(false);
  const handleToggle = () => {
    setToggleState(!toggleState);
    cancelAddNumber();
    editNumberCancel();
  };

  return (
    <Modal size="lg" style={{ maxWidth: '900px' }} isOpen={isOpen}>
      <ModalHeader className="edit-number-port">
        Add new Number
        <Row hidden={vmail}>
          <Label for="enabled" sm={4}>
            Assign New ATA Number
          </Label>
          <Col sm={3} style={{ marginTop: '8px' }}>
            <Toggle value={toggleState} onToggle={() => handleToggle()} />
          </Col>
          <Label for="enabled" sm={4}>
            Port Number
          </Label>
        </Row>
      </ModalHeader>
      <ModalBody>
        {toggleState ? (
          <AddBoxNumber toggleMode={toggleState} boxDetails={boxDetails} />
        ) : (
          <EditBoxAtaNumber
            vmail={vmail}
            toggleMode={toggleState}
            selectRoute={selectRoute}
            gateways={gateways}
            boxDetails={boxDetails}
            onEditPropertyKeyPress={onEditPropertyKeyPress}
          />
        )}
      </ModalBody>
      <ModalFooter>
        <Button outline color="secondary" onClick={onCancel}>
          Cancel
        </Button>
        <Button
          color="primary"
          onClick={() => {
            onConfirm(!toggleState);
          }}
        >
          Save
        </Button>
      </ModalFooter>
    </Modal>
  );
};

const mapStateToProps = state => ({
  company: state.UIState.numbers.addNumber.company,
  type: state.UIState.numbers.addNumber.type,
});

const mapDispatchToProps = dispatch => ({
  addNumberModalCancel: () => dispatch(addNumberModalCancel()),
  getGateways: token => dispatch(getGateways(token)),
  cancelAddNumber: () => dispatch(cancelAddNumber()),
  editNumberCancel: () => dispatch(editNumberCancel()),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(AddAtaBoxNumberModal);
